import { render } from "./warranty-question.vue?vue&type=template&id=776bb6c8"
import script from "./warranty-question.vue?vue&type=script&setup=true&lang=js"
export * from "./warranty-question.vue?vue&type=script&setup=true&lang=js"

import "./warranty-question.vue?vue&type=style&index=0&id=776bb6c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/warranty/warranty-question.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "776bb6c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('776bb6c8', __exports__)) {
    api.reload('776bb6c8', __exports__)
  }
  
  module.hot.accept("./warranty-question.vue?vue&type=template&id=776bb6c8", () => {
    api.rerender('776bb6c8', render)
  })

}


export default __exports__